import {PlusIcon, Trash01Icon} from '@/components/ui/icon/Icon'
import {Menu, MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import {useTranslation} from '@/translations/i18n'
import {useMenuContext} from '@ariakit/react'

interface AgendaBlockoutEventContextMenuProps {
    onChange: (action: 'deleteAbsence' | 'addEvent') => void
    anchorRect: {x: number; y: number}
}

export const AgendaBlockoutEventContextMenu = ({onChange, anchorRect}: AgendaBlockoutEventContextMenuProps) => {
    const contextMenu = useMenuContext()
    const {t} = useTranslation()

    const handleClick = (action: 'deleteAbsence' | 'addEvent') => {
        onChange(action)
        contextMenu?.hide()
    }

    return (
        <Menu store={contextMenu} getAnchorRect={() => anchorRect} modal>
            <MenuItem onClick={() => handleClick('deleteAbsence')}>
                <Trash01Icon />
                {t('accesses:delete_absence_title')}
            </MenuItem>

            <MenuItem onClick={() => handleClick('addEvent')}>
                <PlusIcon />
                {t('commons:dropdown_add_event')}
            </MenuItem>
        </Menu>
    )
}
